import { createDataContext } from '../../../context/DataContext';
import { ClaimSummary } from '../../../Interfaces/Insurance/Claim';

export const {
  DataContextProvider: ClaimSummaryProvider,
  useDataContext: useClaimSummaryContext,
} = createDataContext<ClaimSummary>();
